import { Tooltip } from "components-redesign/Tooltip/Tooltip";
import { numberSort } from "helpers";
import React, { ReactElement } from "react";
import { grayColor } from "vendor/colors";
import {
  AVAILABLE_IDS,
  IDefaultCampaignIdRange,
  UsedInDetail,
} from "./defaultCampaignId";

export enum DefaultNetwork {
  Dataseat = "m8dbw4sv7c.skadnetwork",
  Pubnative = "tl55sbb4fm.skadnetwork",
  Smaato = "m2jqnlggk3.adattributionkit",
}
export const DEFAULT_DEFAULT_NETWORK_ID = DefaultNetwork.Dataseat;
export const DEFAULT_NETWORKS_SORTED_LIST = Object.values(DefaultNetwork).sort(
  (a, b) => (a === DEFAULT_DEFAULT_NETWORK_ID ? -1 : 0)
);

//Usage/availability of Default Ids, per Network
type Option = {
  id: string;
  defaultNetworkId: string;
  isUsed?: boolean;
  usedInDetails;
  label: string;
  labelWithDetails: ReactElement<any, any>;
};

const GreenDot = () => (
  <span
    style={{
      display: "inline-block",
      backgroundColor: "#2E7D32",
      borderRadius: "50%",
      height: 8,
      width: 8,
      marginRight: 4,
      flexShrink: 0,
    }}
  />
);

const TruncatedName = ({ text }: { text: string }) => (
  <Tooltip title={text}>
    <span
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
        maxWidth: "50%",
      }}>
      {text}
    </span>
  </Tooltip>
);

export const getDefaultIdsForNetwork: (
  network: DefaultNetwork,
  usedIds: Record<number, UsedInDetail[] | undefined>
) => Option[] = (network = DEFAULT_DEFAULT_NETWORK_ID, usedIds) => {
  return AVAILABLE_IDS.sort(numberSort).map((id) => {
    const label = `${id} (network: ${network ?? DEFAULT_DEFAULT_NETWORK_ID})`;
    const usedInDetails = usedIds[("" + id) as IDefaultCampaignIdRange]?.filter(
      (d) => (d.defaultNetwork ?? DEFAULT_DEFAULT_NETWORK_ID) === network
    );

    return {
      id: `${id}`,
      defaultNetworkId: network,
      isUsed: (usedInDetails?.length ?? 0) > 0,
      usedInDetails,
      label,
      labelWithDetails: (
        <span>
          <span>{label}</span>
          {usedInDetails && usedInDetails.length > 0 && (
            <span
              style={{
                fontSize: 12,
                color: "#6F797B",
                display: "flex",
                flexDirection: "column",
                gap: 4,
                marginTop: 2,
                fontWeight: "normal",
              }}>
              {usedInDetails.map(
                ({ campaignName, lineitemName, lineitemId, running }) => (
                  <span
                    key={lineitemId}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      width: 365,
                    }}>
                    <TruncatedName text={campaignName} />
                    <span style={{ flexShrink: 0 }}>{" / "}</span>
                    {running && <GreenDot />}
                    <TruncatedName text={lineitemName} />
                  </span>
                )
              )}
            </span>
          )}
        </span>
      ),
    };
  });
};

export const getDefaultIdsOptions = (usedIds) => {
  let values: Option[] = [];
  for (const network of DEFAULT_NETWORKS_SORTED_LIST) {
    values = values.concat(getDefaultIdsForNetwork(network, usedIds));
  }
  return values;
};
